import { Injectable } from '@angular/core';
import { pendoInstall } from '../assets/js/pendo.js';
import { environment } from '../environments/environment';
import { PendoEventTypes } from './PendoEventTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let pendo: any;

@Injectable({
    providedIn: 'root',
})
export class PendoService {
    private maxRetries = 10;
    private retryInterval = 500; // ms
    private retryCount = 0;
    public eventTypes = PendoEventTypes;

    constructor () { }

    install(): void {
        if (!environment.PENDO_API_KEY || !environment.PENDO_ACCOUNT_ID) {
            console.error('Pendo API key or account ID is missing in environment configuration.');
            return;
        }
        pendoInstall(environment.PENDO_API_KEY);
        this.initializeWithRetry();
    }

    track(eventType: PendoEventTypes, metadata: any): void {
        if (!pendo) {
            console.warn('Pendo not loaded yet. Queuing track event:', eventType);
            setTimeout(() => this.track(eventType, metadata), this.retryInterval);
            return;
        }
        try {
            pendo.track(eventType, metadata);
        } catch (error) {
            console.error('Error tracking Pendo event:', error);
        }
    }

    identify(visitorId: string, accountId: string = environment.PENDO_ACCOUNT_ID): void {
        if (!pendo) {
            console.warn('Pendo not loaded yet. Queuing identify.');
            setTimeout(() => this.identify(visitorId, accountId), this.retryInterval);
            return;
        }
        try {
            pendo.identify({
                visitor: { id: visitorId },
                account: { id: accountId },
            });
        } catch (error) {
            console.error('Error identifying Pendo visitor:', error);
        }
    }

    private initializeWithRetry(): void {
        if (pendo) {
            this.initializePendo();
            return;
        }
        if (this.retryCount >= this.maxRetries) {
            console.error('Pendo failed to load after maximum retries.');
            return;
        }
        this.retryCount++;
        setTimeout(() => this.initializeWithRetry(), this.retryInterval);
    }

    private initializePendo(): void {
        try {
            pendo.initialize({
                excludeAllText: true,
                disableCookies: true,
                disablePersistence: true,
                account: {
                    id: environment.PENDO_ACCOUNT_ID,
                },
                visitor: {
                    id: 'VISITOR-UNIQUE-ID', // Replace with dynamic user ID
                },
            });
            console.log('Pendo initialized successfully.');
        } catch (error) {
            console.error('Error initializing Pendo:', error);
        }
    }
}
